import { render } from "./ArrowLeft.vue?vue&type=template&id=136a1ad2&scoped=true"
import script from "./ArrowLeft.vue?vue&type=script&lang=js"
export * from "./ArrowLeft.vue?vue&type=script&lang=js"

import "./ArrowLeft.vue?vue&type=style&index=0&id=136a1ad2&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136a1ad2"]])

export default __exports__